import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import dayjs from "dayjs";
import { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

function Docread(prop) {
  const [readshow, setreadshow] = useState(false);
  const readHandleClose = () => setreadshow(false);
  const readHandleShow = () => setreadshow(true);
  //const url = prop.doc[0].documentUrl;
  console.log("prop_values", prop.forecastAttributes);
  console.log("prop_values_12", prop.data);
  const data = prop.data.forecastStatuses;
  const handleDownload = async (id, documentUrl) => {
    const fileType = documentUrl.split(".").pop();
    try {
      const response = await fetch(documentUrl);
      const blob = await response.blob();

      // Creating a temporary link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Forecast-Order-${id}.${fileType}`; // Specify the filename for the downloaded file

      // Appending the link to the document body
      document.body.appendChild(link);

      // Triggering the download
      link.click();

      // Cleanup: remove the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const [fileshow, setFileshow] = useState(false);
  const [shippedDocList, setShippedDocList] = useState([]);
  const [shippedDocname, setShippedDocname] = useState();
  const [shippedDocdate, setShippedDocdate] = useState();
  const filehandleClose = () => setFileshow(false);
  const filehandleShow = (doc, name, date) => {
    setFileshow(true);
    setShippedDocList(doc);
    setShippedDocname(name);
    setShippedDocdate(date);
  };

  const handleDownloads = async (name, fileType, documentUrl) => {
    //const fileType = documentUrl.split(".")[4]
    try {
      const response = await fetch(documentUrl);
      const blob = await response.blob();
      console.error("downloading file:", documentUrl.split("."));
      // Creating a temporary link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${name}.${fileType}`; // Specify the filename for the downloaded file

      // Appending the link to the document body
      document.body.appendChild(link);

      // Triggering the download
      link.click();

      // Cleanup: remove the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  console.log("prop_data", prop);
  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        onClick={readHandleShow}
      >
        {" "}
        <i className="bi bi-eye"></i>
      </button>
      <Modal
        show={readshow}
        s
        size="lg"
        onHide={readHandleClose}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>#{prop.data.id} Forecast Details</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body><div dangerouslySetInnerHTML={{ __html: prop.data }}></div>
                            <br/>
                            <a href={`${url}`} target="_blank"><img src="/assets/images/pdf.png" class="" width="40px" height="auto" alt=""/></a>
                            </Modal.Body> */}
        <Modal.Body>
          <Form noValidate>
            <Row className="mb-3">
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <Form.Label>
                  <b>Principal</b>
                </Form.Label>
                <Form.Control
                  value={prop.data.userPrinciple.name}
                  disabled
                ></Form.Control>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom02">
                <Form.Label>
                  <b>Product Code</b>
                </Form.Label>
                <Form.Control
                  value={prop.data.productCode}
                  disabled
                ></Form.Control>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom02">
                <Form.Label>
                  <b>Product Name</b>
                </Form.Label>

                <Form.Control
                  value={prop.data.productName}
                  disabled
                ></Form.Control>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="4" controlId="validationCustom01">
                <Form.Label>
                  <b>Month</b>
                </Form.Label>
                <Form.Control value={prop.data.month} disabled></Form.Control>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom02">
                <Form.Label>
                  <b>Price</b>
                </Form.Label>
                {console.log("forcast prop", prop)}
                <Form.Control value={prop.data.price} disabled></Form.Control>
              </Form.Group>
              <Form.Group as={Col} md="4" controlId="validationCustom03">
                <Form.Label>
                  <b>Product Annual Budget</b>
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  value={prop.data.annualBudget}
                  disabled
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              {prop.data.forecastAttributes.map((item, index) => (
                <Form.Group as={Col} md="4" controlId="validationCustom04">
                  <Form.Label>
                    <b>{item.name}</b>
                  </Form.Label>
                  <Form.Control type="text" disabled value={item.value} />
                </Form.Group>
              ))}
            </Row>
            <Row className="mb-3">
              {prop.data.forecastAttributes.map((item, index) => (
                <Form.Group as={Col} md="4" controlId="validationCustom05">
                  <Form.Label>
                    <b>{item.name} Total Values</b>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    // value={item.value * prop.data.price}
                    value={item.amount}
                  />
                </Form.Group>
              ))}
            </Row>

            <Row>
              <Col className="mt-3">
                <Form.Label>
                  <b>Track Status</b>
                </Form.Label>
                <div class="history-tl-container">
                  <ul class=" tl virtical">
                    {data?.map((item) => (
                      <li class="tl-item" ng-repeat="item in retailer_history">
                        <div class="timestamp">
                          {item.order_Status_Enum == "SHIPPED" ? (
                            <span
                              onClick={() =>
                                filehandleShow(
                                  item.shippedDocumentations,
                                  item.order_Status_Enum,
                                  item.updatedAt
                                )
                              }
                            >
                              <i class="fa fa-files-o"></i>{" "}
                              {item.shippedDocumentations.length} Files
                            </span>
                          ) : null}
                          {dayjs(item.updatedAt).format("DD MMM YYYY")}
                          <br /> {dayjs(item.updatedAt).format("hh : mm A")}
                        </div>
                        <div class="item-title">{item.order_Status_Enum}</div>
                        <div class="item-detail">{item.comment}</div>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={readHandleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={fileshow}
        onHide={filehandleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="shippedDocList"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {shippedDocname} - {dayjs(shippedDocdate).format("DD MMM YYYY")} -{" "}
            {dayjs(shippedDocdate).format("hh : mm A")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="orderShipList">
            {shippedDocList.length > 0 ? (
              shippedDocList.map((item) => (
                <li>
                  <div className="filename">
                    {item.name}.{item.fileType}
                  </div>
                  <button
                    onClick={(e) =>
                      handleDownloads(
                        item.name,
                        item.fileType,
                        item.documentUrl
                      )
                    }
                  >
                    <img src="/assets/images/download.png" />
                  </button>
                </li>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  height: "150px",
                }}
              >
                <img
                  src="/assets/images/no-document.png"
                  style={{ width: "100px" }}
                />
                <p style={{ margin: 0 }}>
                  <b>No Documents</b>
                </p>
              </div>
            )}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={filehandleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Docread;
